import { Phone } from "lucide-react";
import { SITE } from "@/site";

export const MobileCallBar = () => (
  <div className="fixed bottom-0 inset-x-0 z-50 md:hidden border-t border-slate-200 bg-white/95 backdrop-blur-md px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
    <a
      href={SITE.phoneHref}
      data-testid="mobile-persistent-call-button"
      className="flex items-center justify-center gap-2.5 rounded-full bg-navy py-3.5 font-heading text-base font-bold text-white active:scale-[0.98] transition-transform"
    >
      <Phone size={18} strokeWidth={2.4} />
      Call for Appointment — {SITE.phoneDisplay}
    </a>
  </div>
);
